import {Question, TypeOption} from '@app/models';

const question1: Question = {
  id: 1,
  label: `Elle débarque avec une envie folle (ex: apprendre le piano, changer de métier)`,
  options: [
    {
      label: `Je lui sors la liste des factures et je lui explique qu'on n'est pas chez les Bisounours.`,
      value: TypeOption.A
    },
    {
      label: `Je dis « C’est super » sans lever les yeux de mon téléphone, en espérant qu’elle oublie l'idée demain.`,
      value: TypeOption.B
    },
    {
      label: `Je m'assois avec elle et je demande : « Qu'est-ce qui te fait vibrer là-dedans ? ». On explore le rêve ensemble.`,
      value: TypeOption.C
    }
  ]
}

const question2: Question = {
  id: 2,
  label: `Elle essaie de vous murmurer un avertissement (un mauvais pressentiment, un besoin de calme).`,
  options: [
    {
      label: `Je lui dis qu’elle est "trop sensible" et qu’elle devrait arrêter de se faire des films.`,
      value: TypeOption.A
    },
    {
      label: `Je l'écoute par politesse, mais je continue mon planning comme si elle n'avait rien dit.`,
      value: TypeOption.B
    },
    {
      label: `Je m'arrête tout de suite. Si elle a peur ou mal, c'est ma priorité numéro 1.`,
      value: TypeOption.C
    }
  ]
}

const question3: Question = {
  id: 3,
  label: `Vous l'emmenez dans un job ou une situation qui l'ennuie à mourir.`,
  options: [
    {
      label: `Je lui dis de faire un effort et d'arrêter de me faire honte avec sa tête d'enterrement.`,
      value: TypeOption.A
    },
    {
      label: `Je culpabilise un peu, alors je lui promets une récompense plus tard pour qu’elle se taise maintenant.`,
      value: TypeOption.B
    },
    {
      label: `Je surveille son éclat. Si je vois qu'elle s'éteint, on s'éclipse. Sa lumière vaut plus que ce contrat.`,
      value: TypeOption.C
    }
  ]
}

const question4: Question = {
  id: 4,
  label: `Quel est votre dernier "cadeau" pour elle (sans raison particulière) ?`,
  options: [
    {
      label: `Rien. Le temps, c'est de l'argent, et elle en consomme déjà bien assez.`,
      value: TypeOption.A
    },
    {
      label: `Un moment de détente par mois, quand je n'ai vraiment plus rien d'autre à faire.`,
      value: TypeOption.B
    },
    {
      label: `Un rendez-vous quotidien : 10 minutes de musique, de danse ou de silence, juste pour elle.`,
      value: TypeOption.C
    }
  ]
}

const question5: Question = {
  id: 5,
  label: `Si quelqu'un au travail juge votre flamme (votre enthousiasme) "peu professionnelle".`,
  options: [
    {
      label: `Je lui donne raison et je demande à ma flamme de rester à la maison (ou de porter un costume gris).`,
      value: TypeOption.A
    },
    {
      label: `Je défends ma flamme mollement, mais je lui demande d'être plus discrète la prochaine fois.`,
      value: TypeOption.B
    },
    {
      label: `Je réponds que c’est précisément cet enthousiasme qui fait ma valeur.`,
      value: TypeOption.C
    }
  ]
}

const question6: Question = {
  id: 6,
  label: `Le soir, dans votre foyer intérieur, quelle est l'ambiance ?`,
  options: [
    {
      label: `Un silence de plomb. Elle boude dans sa chambre et je fais semblant de ne pas le voir.`,
      value: TypeOption.A
    },
    {
      label: `Une colocation polie. On cohabite, mais on ne se "voit" plus vraiment.`,
      value: TypeOption.B
    },
    {
      label: `Une complicité vibrante. On partage tout, les doutes comme les étincelles.`,
      value: TypeOption.C
    }
  ]
}

const question7: Question = {
  id: 7,
  label: `Elle est épuisée et vous supplie de ralentir.`,
  options: [
    {
      label: `Je la traite de paresseuse et je la force à avancer. « On se reposera quand on sera mort ! ».`,
      value: TypeOption.A
    },
    {
      label: `Je lui donne un café (ou un complément alimentaire) et je lui demande de tenir jusqu'au week-end.`,
      value: TypeOption.B
    },
    {
      label: `J'annule mes rendez-vous non vitaux. Si mon partenaire tombe, je m'arrête avec lui.`,
      value: TypeOption.C
    }
  ]
}

const question8: Question = {
  id: 8,
  label: `Elle devient soudainement rayonnante, belle et attire tous les regards.`,
  options: [
    {
      label: `Ça m'agace. Je cherche le petit détail qui ne va pas pour la faire redescendre d'un cran.`,
      value: TypeOption.A
    },
    {
      label: `Ça m'inquiète. J'ai peur qu'elle finisse par me trouver trop terne et qu'elle me quitte.`,
      value: TypeOption.B
    },
    {
      label: `Je suis son premier fan. Je suis fier de marcher à ses côtés, peu importe si elle me vole la vedette.`,
      value: TypeOption.C
    }
  ]
}

const question9: Question = {
  id: 9,
  label: `Vous avez une grosse dispute (un échec, une erreur) et elle est blessée.`,
  options: [
    {
      label: `Je lui rappelle que c’est de sa faute et je lui fais la tête pendant trois jours pour qu’elle comprenne la leçon.`,
      value: TypeOption.A
    },
    {
      label: `Je fais comme si de rien n’était. Le temps finit toujours par tasser les choses, pas besoin d’en discuter.`,
      value: TypeOption.B
    },
    {
      label: `Je prends ma part de responsabilité. Je vais la voir et je lui demande : « Comment est-ce qu’on peut se réconcilier ?`,
      value: TypeOption.C
    }
  ]
}

const question10: Question = {
  id: 10,
  label: `Elle te ressort une vieille blessure ou une peur du passé.`,
  options: [
    {
      label: `Je m'énerve : « Encore ça ? On ne va pas passer notre vie à pleurer sur le passé, avance ! ».`,
      value: TypeOption.A
    },
    {
      label: `Je l'écoute avec un soupir, en attendant que la crise passe pour qu'on puisse enfin parler de choses sérieuses.`,
      value: TypeOption.B
    },
    {
      label: `Je l'accueille avec tendresse. Je sais que ses cicatrices font partie de notre histoire et je la rassure.`,
      value: TypeOption.C
    }
  ]
}

const question11: Question = {
  id: 11,
  label: `Le quotidien devient un peu trop "routinier" et monotone.`,
  options: [
    {
      label: `Je lui reproche d'être devenue ennuyeuse et je regarde avec envie la flamme des autres sur les réseaux.`,
      value: TypeOption.A
    },
    {
      label: `Je ne dis rien, c'est la vie. L'amour passion, c'est pour les films, pas pour la réalité.`,
      value: TypeOption.B
    },
    {
      label: `Je prépare une surprise. Un nouveau projet, un voyage ou juste une folie pour lui prouver que je tiens à nous.`,
      value: TypeOption.C
    }
  ]
}

export const questions = [
  question1, question2, question3, question4, question5, question6, question7, question8, question9, question10, question11
]
